// src/components/BottomNavigation.js
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './BottomNavigation.css';

const BottomNavigation = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const hiddenRoutes = ['/login', '/complete-profile'];
    if (hiddenRoutes.includes(location.pathname)) return null;

    return (
        <div className="bottom-nav-bar">
            {/* 1. Home Tab */}
            <button 
                className={`nav-item ${location.pathname === '/' ? 'active' : ''}`}
                onClick={() => navigate('/')}
            >
                <i className="fas fa-home"></i>
                <span>Home</span>
            </button>

            {/* 2. Top Stories Tab */}
            <button 
                className={`nav-item ${location.pathname === '/posts/TopNews' || location.pathname === '/posts/Top%20News' ? 'active' : ''}`}
                onClick={() => navigate('/posts/TopNews')}
            >
                <i className="fas fa-fire-alt"></i> {/* Upgraded to Fire/Trending Icon */}
                <span>Top News</span>
            </button>

            {/* 3. Local News Tab */}
            <button 
                className={`nav-item ${location.pathname === '/posts/LocalNews' ? 'active' : ''}`}
                onClick={() => navigate('/posts/LocalNews')}
            >
                <i className="fas fa-map-marked-alt"></i> {/* Upgraded to Map-Marked Icon */}
                <span>Local</span>
            </button>

            {/* 4. Categories Tab */}
            <button 
                className={`nav-item ${location.pathname === '/explore' ? 'active' : ''}`}
                onClick={() => navigate('/explore')}
            >
                <i className="fas fa-layer-group"></i> {/* Upgraded to Layered Categories Icon */}
                <span>Categories</span>
            </button>

            {/* 5. Wishes Tab */}
            <button 
                className={`nav-item ${location.pathname === '/posts/Special Day Wishes' || location.pathname === '/posts/Special%20Day%20Wishes' ? 'active' : ''}`}
                onClick={() => navigate('/posts/Special Day Wishes')}
            >
                <i className="fas fa-gift"></i>
                <span>Wishes</span>
            </button>
        </div>
    );
};

export default BottomNavigation;